/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisterUploadEndpointRequest
 */
export interface RegisterUploadEndpointRequest {
    /**
     * 
     * @type {string}
     * @memberof RegisterUploadEndpointRequest
     */
    uploadId: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterUploadEndpointRequest
     */
    path: string;
}

export function RegisterUploadEndpointRequestFromJSON(json: any): RegisterUploadEndpointRequest {
    return RegisterUploadEndpointRequestFromJSONTyped(json, false);
}

export function RegisterUploadEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterUploadEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uploadId': json['upload_id'],
        'path': json['path'],
    };
}

export function RegisterUploadEndpointRequestToJSON(value?: RegisterUploadEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'upload_id': value.uploadId,
        'path': value.path,
    };
}


